const initState = {
    actions: [],
    /**control */
    connection:false,
    error:false,
    message:"",

};

export default initState;